import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      "fill-opacity": ".18",
      d: "M9 20q-.825 0-1.412-.587A1.93 1.93 0 0 1 7 18q0-.825.588-1.412Q8.177 16.002 9 16a1.92 1.92 0 0 1 1.413.588q.59.59.587 1.412a1.95 1.95 0 0 1-.587 1.413A1.9 1.9 0 0 1 9 20m6 0q-.825 0-1.412-.587A1.93 1.93 0 0 1 13 18q0-.825.588-1.412.589-.586 1.412-.588a1.92 1.92 0 0 1 1.413.588q.59.59.587 1.412a1.95 1.95 0 0 1-.587 1.413A1.9 1.9 0 0 1 15 20m-6-6q-.825 0-1.412-.587A1.93 1.93 0 0 1 7 12q0-.825.588-1.412Q8.177 10.002 9 10a1.92 1.92 0 0 1 1.413.588q.59.59.587 1.412a1.95 1.95 0 0 1-.587 1.413A1.9 1.9 0 0 1 9 14m6 0q-.825 0-1.412-.587A1.93 1.93 0 0 1 13 12q0-.825.588-1.412.589-.586 1.412-.588a1.92 1.92 0 0 1 1.413.588q.59.59.587 1.412a1.95 1.95 0 0 1-.587 1.413A1.9 1.9 0 0 1 15 14M9 8q-.825 0-1.412-.587A1.93 1.93 0 0 1 7 6q0-.825.588-1.412Q8.177 4.002 9 4a1.92 1.92 0 0 1 1.413.588q.59.59.587 1.412a1.95 1.95 0 0 1-.587 1.413A1.9 1.9 0 0 1 9 8m6 0q-.825 0-1.412-.587A1.93 1.93 0 0 1 13 6q0-.825.588-1.412Q14.177 4.002 15 4a1.92 1.92 0 0 1 1.413.588q.59.59.587 1.412a1.95 1.95 0 0 1-.587 1.413A1.9 1.9 0 0 1 15 8"
    }, null, -1)
  ]))]))
}
export default { render: render }